import { login, infoMation, myDetail } from "@/api/user";
import { getToken, removeToken } from "@/utils/auth";
import { setLoginStatus } from "@/utils/auth";

const state = {
  token: getToken(),
  name: "",
  phone: "",
  email: "",
  avatar: "",
  introduction: "",
  roles: [],
  firstLogin: false,
  userInfo: {},
  isAdmin: sessionStorage.getItem("iwrs_root"),
  roleName: "", // 角色名
  routerRoles: null,
  isManager: false
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_PHONE: (state, phone) => {
    state.phone = phone;
  },
  SET_EMAIL: (state, email) => {
    state.email = email;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_FIRST_LOGIN: (state, firstLogin) => {
    state.firstLogin = firstLogin;
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_ROLENAME: (state, roleName) => {
    state.roleName = roleName;
  },
  SET_IS_ADMIN: (state, isAdmin) => {
    state.isAdmin = isAdmin;
  },
  SET_ROUTER_ROLES: (state, routerRoles) => {
    state.routerRoles = routerRoles;
  }
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { phone, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({ phone: phone.trim(), password: password })
        .then(response => {
          const { code, data } = response;
          if (code === 0 && data) {
            setLoginStatus();
            console.log(data);
            commit("SET_USER_INFO", data.user);
            commit("SET_FIRST_LOGIN", data.user.is_update_password);
            commit("SET_PHONE", data.user.phone);
            commit("SET_NAME", data.user.name);
            sessionStorage.setItem("iwrs_user", JSON.stringify(data.user));
            commit("SET_EMAIL", data.user.email);
            commit("SET_AVATAR", null);
            if (data.user.name === "超级管理员") {
              commit("SET_IS_ADMIN", true);
            }
          }
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // userroleName
  getRole({ commit }, proId) {
    // console.log(proId)
    return new Promise((resolve, reject) => {

      if (!proId) {
        commit("SET_ROLENAME", "");
        resolve();
      } else {
        myDetail({ project_id: proId })
          .then(response => {
            const { code, data } = response;
            // success
            if (code === 0) {
              commit("SET_ROLENAME", data.role_name);
              if (data.is_manager) {
                commit("SET_IS_ADMIN", true);
              }
              if (data.all_authority3) {
                // let projectInfo = JSON.parse(sessionStorage.getItem('iwrs_project'))
                // if(data.role_name==='项目管理员'&& projectInfo.is_synchro_edc){
                //   data.all_authority3['受试者配置']=[]
                // }
                commit("SET_ROUTER_ROLES", data.all_authority3);
                const values = Object.values(data.all_authority3);
                let arr = [];
                values.map(item => {
                  arr = arr.concat(item);
                });
                commit("SET_ROLES", arr);
                resolve(data.all_authority3);
              }
            }
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      let user = JSON.parse(sessionStorage.getItem("iwrs_user"));
      infoMation({
        user_id: user.id
      }).then(response => {
        const { success, data } = response;
        if (success && data) {
          commit("SET_PHONE", data.phone);
          commit("SET_NAME", data.name);
          commit("SET_EMAIL", data.email);
          commit("SET_AVATAR", null);
          if (data.name === "超级管理员") {
            commit("SET_IS_ADMIN", true);
          }
        }
        resolve();
      });
    });
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      commit("SET_ROLES", []);
      commit("SET_NAME", null);
      commit("SET_IS_ADMIN", false);
      removeToken();
      dispatch("tagsView/delAllViews", null, { root: true });
      resolve();
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      removeToken();
      resolve();
    });
  },

  // 设置首次登陆标识
  setFirstLogin({ commit }, data) {
    console.log("表示过");
    console.log(data);
    return new Promise(resolve => {
      commit("SET_FIRST_LOGIN", data);
      resolve();
    });
  },
  // user roleName
  getRoleName({ commit }, proId) {
    return new Promise((resolve, reject) => {
      commit("SET_ROLENAME", "测试");
      resolve("测试");
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
